const markedEvents = new WeakSet();

/**
 * Cache event as "marked"
 */
export function markEvent(event) {
  if (typeof event.persist === 'function') event.persist();
  markedEvents.add(event);
}

/**
 * Determine if event is "marked"
 */
export function isEventMarked(event) {
  return markedEvents.has(event);
}
//# sourceMappingURL=marked-events.js.map